import { render, staticRenderFns } from "./AppSecondTitle.vue?vue&type=template&id=10443c22&scoped=true&"
import script from "./AppSecondTitle.vue?vue&type=script&lang=ts&"
export * from "./AppSecondTitle.vue?vue&type=script&lang=ts&"
import style0 from "./AppSecondTitle.vue?vue&type=style&index=0&id=10443c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10443c22",
  null
  
)

export default component.exports